export const contentTableConfig = {
  title: '角色列表',
  propList: [
    { prop: 'roleName', label: '角色名', minWidth: '60' },
    { prop: 'displayName', label: '显示名', minWidth: '60' },
    { prop: 'sort', label: '排序', minWidth: '80' },
    { prop: 'userNum', label: '账号数量', minWidth: '80' },
    { prop: 'status', label: '状态', minWidth: '60', slotName: 'status' },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '120',
      slotName: 'createdTime'
    },
    {
      prop: 'updatedTime',
      label: '更新时间',
      minWidth: '120',
      slotName: 'updatedTime'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
